/**
 * 工作报告管理路由配置
 */
const workReportRoute = {
  path: 'work-report',
  name: 'workReport',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'workReportList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '工作报告管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default workReportRoute;
